<template>
  <b-card
    border-variant="primary" header-bg-variant="primary" header-text-variant="white"
    header-class="p-3 font-size-lg font-weight-bold"
    header="Premium & Government Charges"
  >
    <table class="table table-sm table-bordered mb-0">
      <thead>
        <th width="70%" class="text-center">Component</th>
        <th width="30%" class="text-center">Amount</th>
      </thead>
      <tr>
        <td class="align-middle">Base Premium</td>
        <td class="text-right">{{ premium.base | currency }}</td>
      </tr>
      <tr>
        <td class="align-middle">Fire Services Levy (FSL)</td>
        <td class="text-right">{{ premium.fsl | currency }}</td>
      </tr>
      <tr>
        <td class="align-middle">Stamp Duty</td>
        <td class="text-right">{{ premium.stampDuty | currency }}</td>
      </tr>
      <tr>
        <td class="align-middle">Insurer GST</td>
        <td class="text-right">{{ premium.insurerGst | currency }}</td>
      </tr>
      <tr>
        <td class="align-middle font-weight-bolder" style="background-color: lightgray">
          <b-badge variant="primary">Gross</b-badge>
        </td>
        <td class="text-right font-weight-bolder" style="background-color: lightgray">
          {{ premium.gross | currency }}
        </td>
      </tr>
    </table>
  </b-card>
</template>

<script>
export default {
  name: "PremiumCard",

  props: {
    premium: {
      type: Object,
      required: true
    }
  }
};
</script>
